export function Space() {
  return `
    <section class="space">
      <div class="space__content">
        <div class="space__title-container">
          <h2 class="space__title text-xl font-medium">Gli Spazi</h2>
          <p class="space__desc text-base font-medium">
            Ogni ambiente è stato progettato con cura, unendo design contemporaneo e funzionalità.<br/>
            Le attrezzature di ultima generazione si integrano in spazi eleganti, per offrire un’esperienza d’allenamento senza compromessi.
          </p>
        </div>
        <div class="space__slider-container">
          <div class="space__slider slider">
            <img src="/images/spaces/forma-studio-space-1.webp" alt="Forma Studio Space Palestra" draggable="false" />
            <img src="/images/spaces/forma-studio-space-2.webp" alt="Forma Studio Space Pesi" draggable="false" />
            <img src="/images/spaces/forma-studio-space-3.webp" alt="Forma Studio Space Pilates Reformer" draggable="false" />
            <img src="/images/spaces/forma-studio-space-4.webp" alt="Forma Studio Space Attrezzature Pilates Reformer" draggable="false" />
            <img src="/images/spaces/forma-studio-space-5.webp" alt="Forma Studio Space Fisioterapia" draggable="false" />
            <img src="/images/spaces/forma-studio-space-6.webp" alt="Forma Studio Space Consulenza" draggable="false" />
            <img src="/images/spaces/forma-studio-space-7.webp" alt="Forma Studio Space Relax" draggable="false" />
            <img src="/images/spaces/forma-studio-space-8.webp" alt="Forma Studio Space Spogliatoi" draggable="false" />
            <img src="/images/spaces/forma-studio-space-9.webp" alt="Forma Studio Space Dress Room" draggable="false" />
          </div>
          <div class="space__slider-controls">
            <div class="space__slider-control slider-controls">
              <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.48581 0.292969L0.778704 6.00007L6.48581 11.7072L7.90002 10.293L3.60713 6.00007L7.90002 1.70718L6.48581 0.292969Z" fill="white"/>
              </svg>
            </div>
            <div class="space__slider-control slider-controls">
              <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.51419 11.707L7.2213 5.99993L1.51419 0.292818L0.0999765 1.70703L4.39287 5.99993L0.0999757 10.2928L1.51419 11.707Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  `;
}